/**
 * Global Application Configuration & Feature Flags
 */

export const APP_CONFIG = {
    // Application Meta
    NAME: 'Ikigai Lab',
    VERSION: '1.2.0',

    // Feature Flags
    FEATURES: {
        // Master switch for the "Life Operating System" (v2 Architecture)
        // Set to false to hide all v2 UI elements (Dual Boot, Radar Chart)
        ENABLE_LIFE_OS_V2: false,

        // Other potential flags
        ENABLE_VOICE_MODE: true,
        ENABLE_USER_STATS: true
    }
};
